import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';


const marks = [
  {
    value: seconds_to_x(60),// 30.92552438994078,
    label: '1 minute',
  },
  {
    value: seconds_to_x(60*60),//43.99172323494776,
    label: '1 hour',
  },
  {
    value: seconds_to_x(60*60*24),//52.66280973201594,
    label: '1 day',
  },
  {
    value: seconds_to_x(60*60*24*365),//68.70292601666763,
    label: '1 year',
  },
  {
    value: seconds_to_x(60*60*24*365*100),//81.22176996710447,
    label: '100 years'
  },
  {
    value: seconds_to_x(60*60*24*365*9999),
    label: '10000 years'
  }
];

function valuetext(value) {
  return `${value}°C`;
}

function slider_to_seconds(x){
    /*let sr = 1 // lower bound estimate on SR
    let seconds_per_year = 60*60*24*365
    let maximum_years = 99999 
    let max_t = seconds_per_year * sr * maximum_years
    let p = 2 // power 
    let max_exp = Math.log(max_t)/Math.log(p)
    let seconds = Math.pow(p,(max_exp/100*x))
    return seconds*/
    return Math.pow(2,0.41520122393119840000*x)-1
}

function seconds_to_x(seconds){
  return 3.47469 * Math.log(seconds+1)
}


class TimeSlider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: 0,
      scrublock: false,
      seconds: this.props.seconds || 0,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.seconds !== this.props.seconds && !this.state.scrublock) {
      this.setState({
        seconds: this.props.seconds,
        value: seconds_to_x(this.props.seconds)
      })
    }
  }
  
  handleSliderChange = (event, newValue) => {
    let value = newValue;
    let seconds = slider_to_seconds(value);
    this.setState({value: value, seconds: seconds, scrublock: true});
    this.props.update_seconds(seconds)
    setTimeout(function(){
      this.setState({scrublock:false})
    }.bind(this),0)
  };


  render() {
    return (
      <div className="time-machine noselect">
        <Slider
          value={typeof this.state.value === 'number' ? this.state.value : 0}
          onChange={this.handleSliderChange}
          defaultValue={20}
          getAriaValueText={valuetext}
          aria-labelledby="slider-custom"
          step={0.01}
          valueLabelDisplay="off"
          marks={marks}
        />
      </div>
    );
  }
}

export default TimeSlider;
